module.exports = {
  publicPath: '/fleetadmin/',
}